import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "message__icon"
};
const _hoisted_2 = { class: "message__text" };
import Sprite from "./Sprite.vue";
import { computed } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Message',
    props: {
        gray: Boolean,
        strong: Boolean,
        icon: String,
    },
    setup(__props) {
        const props = __props;
        const classNames = computed(() => ({
            'message message--md': true,
            'message--gray': props.gray,
            'message--strong': props.strong,
            'message--icon': props.icon,
        }));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(classNames.value)
            }, [
                (__props.icon)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(Sprite, {
                            name: __props.icon,
                            size: "32"
                        }, null, 8 /* PROPS */, ["name"])
                    ]))
                    : _createCommentVNode("v-if", true),
                _cache[0] || (_cache[0] = _createTextVNode()),
                _createElementVNode("div", _hoisted_2, [
                    _renderSlot(_ctx.$slots, "default")
                ])
            ], 2 /* CLASS */));
        };
    }
});
